import format from "date-fns/format";
import React from "react";
import { HeaderProps } from "react-big-calendar";
import styled, { css } from "styled-components";
import { getDateIsoString } from "@lifeat/shared/util/DateUtil";
import { FontSize } from "@themes/Fonts";

const WeekHeaderContainer = styled.div<{ isToday: boolean }>`
    display: flex;
    width: 100%;
    height: 100%;
    font-size: ${FontSize.normal};

    ${(props) =>
        props.isToday &&
        css`
            background-color: ${props.theme.textColorPrimary};
            padding: 4px 6px;
            border-radius: 7px;
        `}
    color: ${(props) => (props.isToday ? props.theme.backgroundPrimary : props.theme.textColorPrimary)};
`;

const TaskDateColumnHeaderBold = styled.div`
    font-weight: 550;
`;

function CalendarWeekViewHeader(props: HeaderProps) {
    const isToday = getDateIsoString(new Date()) === getDateIsoString(props.date);
    return (
        <WeekHeaderContainer isToday={isToday}>
            <TaskDateColumnHeaderBold>{format(props.date, "EEE d")}</TaskDateColumnHeaderBold>
            {format(props.date, ", MMM")}
        </WeekHeaderContainer>
    );
}

export default CalendarWeekViewHeader;
